




































































import mixins from 'vue-typed-mixins';
import selectSwatch from '@/mixins/Customizer/SelectSwatch';
import StandardNavigationMixin from "@/mixins/Customizer/StandardNavigation";
import {
  ItemObject,
  TreeNode,
} from "@/components/Customizer/StandardNavigation/StandardNavigation.t";
import { GDMState, IGraphic, GraphicComponent } from "@/libs/graphics/types/Graphics.t";
import StandardNavigationItem from "./StandardNavigationItem/StandardNavigationItem.vue";
import { IPDM } from '@/store/modules/utils/util.t';
import { IComponentRecipe, IComponentTemplate, IDefaultRecipe, SwatchRelation } from '@/store/modules/recipe/recipe.t';
const cloneDeep = require("lodash/cloneDeep");

const cameraIcon = 'icon-camera-solid';
const editIcon = 'icon-edit-solid';
let _uuid: number = 0;

export default mixins(selectSwatch, StandardNavigationMixin).extend({
  name: "StandardNavigation",
  components: { StandardNavigationItem },
  props: {
    initialActiveItemId: {
      type: String,
      required: false,
      default: null,
    },
    updateActiveIdOnActivate: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  data() {
    return {
      activeItemId: null as number | string | null,
      focusedTreeItem: null as null | ItemObject,
      isVisible: true as boolean,
      items: [] as ItemObject[],
      updatedFlag: false as boolean,
      uuid: 0 as number,
      ActiveItemSwatch: false as boolean,
      updateItems: false as boolean,
      gdmElements: 0 as number
    };
  },
  computed: {
    assetsPath(): string {
      return (this.$store as any).state.endPoints.customizer.customsAssets;
    },
    gdm(): GDMState{
      return this.$store.state.gdm;
    },
    pdm(): IPDM{
      return this.$store.state.utils.pdm;
    },
    recipe_v2(): IDefaultRecipe {
      return this.$store.state.recipe.recipe_v2;
    },
    standardNavigation(): any {
      return this.$store.state.standardNavigation;
    },
    translations(){
      return this.$store.state.translations.data;
    },
    combinedApparel(): string {
      return `${this.standardNavigation.activeComponent}|${this.standardNavigation.activeSubComponent}`
    },
    selectedSwatch(): any {
      return this.$store.state.swatches.selectedSwatches;
    },
    activeComponent(): string {
      if (this.isApparel){
        return this.$store.state.standardNavigation.activeSubComponent !== '' ?
        `${this.$store.state.standardNavigation.activeComponent}/${this.$store.state.standardNavigation.activeSubComponent}`:
          this.$store.state.standardNavigation.activeComponent;
      }
      else {
        return this.$store.state.legacyNavigation.activeComponent;
      }
    },
    enablePersonalization() {
      return this.$store.getters['utils/isPersonalizationEnabled'];
    },
    enableUGC() {
      return this.$store.getters['utils/isUGCenabled'];
    },
    isStandardMenuOpen(): boolean {
      return this.$store.getters['standardNavigation/isStandardMenuOpen'];
    },
    isApparel(): boolean {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    noPaletteLockOrUniqueSwatches() {
      return !(this.$store.getters['swatches/lockedPalettes'].length + this.$store.getters['swatches/uniqueSwatches'].length);
    },
    externalHeadersVisible() {
      return this.$store.state.utils.externalHeadersVisible && !this.$store.getters['utils/regionIsApac'];
    },
    zoomLevelHigh() {
      return this.$store.state.utils.zoomLevel >= 200;
    },
  },
  watch: {
    ['recipe_v2.components'](newVal) {
      const component = this.activeComponent.split('/');

      if (newVal !== undefined && this.pdm && (this.gdm.data.length > 0 || !this.isApparel) && this.updatedFlag) {
        this.updatedFlag = false;
        this.createMainNav();
      } else if (!this.isApparel && newVal[this.activeComponent]?.hasOwnProperty('ugc') ||
        this.isApparel && newVal[component[0]]?.sub_components?.[component[1]]?.hasOwnProperty('ugc')) {
        this.updateMainNav(this.standardNavigation.menu);
      }
    },
    ["gdm.data"](newVal) {
      if (newVal !== undefined && this.pdm && (this.gdm.data.length > 0 || !this.isApparel) && !this.updatedFlag && this.recipe_v2?.components) {
        this.updatedFlag = true;
        this.gdmElements = newVal.length;
        this.createMainNav();
      }

      if ((this.gdmElements !== newVal.length) && this.gdmElements !== 0){
        this.gdmElements = newVal.length;
        this.createMainNav();
      }
    },
    ['standardNavigation.activeComponent'](newVal){
      if(this.ActiveItemSwatch)
        this.activedItemBySwatch(newVal);
      else
        this.ActiveItemSwatch = true;
    },
    combinedApparel(newVal, oldVal){
      const newValue = newVal.split('|');
      const oldValue = oldVal.split('|');
      if(this.ActiveItemSwatch) {
        if (newValue[1] === '' && (newValue[1] !== oldValue[1])){
           this.updateMainNav(this.standardNavigation.menu);
           this.activeItemId = newValue[0];
        } else if (newValue[1] !== '' && (newValue[1] !== oldValue[1])){
           this.activeItemId = newValue[1];
        } else if (newValue[1] === '' && (newValue[1] === '' && oldValue[1] === '')){
           this.updateMainNav(this.standardNavigation.menu);
           this.activeItemId = newValue[0];
        }
      }
    },
    ['standardNavigation.menu'](newVal){
      if (this.updateItems)
        this.updateMainNav(newVal);
      else
        this.updateItems = true;
    }
  },
  methods: {
    activedItemBySwatch(id: string){
      this.activeItemId = id;
        const expandedItem = this.items.find(item => item.id === id);
        const expandedItemPos = this.items.findIndex(item => item.id === id);
        this.items.forEach((item) => {
          if (item !== expandedItem) {
            const pos = this.items.indexOf(item);
            (this.$refs[`standard-navigation-item-${pos}`] as any)[0].collapse();
          }
        });

        if ((this.$refs[`standard-navigation-item-${expandedItemPos}`] as any))
          (this.$refs[`standard-navigation-item-${expandedItemPos}`] as any)[0].isExpanded= true;
    },
    createMainNav() {
      this.items = [];
      const tempItems: ItemObject[] = [];
      const featureAllowed = this.checkFeatureAllowed();
      const { ugcAllowed } = featureAllowed;

      if (this.recipe_v2.components) {
        (this as any).setSwatchesSelectedFromRecipe(this.recipe_v2);
        this.pdm.component_order.forEach((componentName: keyof IComponentRecipe) => {
          const pdmComponent = this.pdm.components[componentName];
          if (componentName === "graphic_sleeve_left") return;
          const componentInRecipe = this.recipe_v2.components[componentName];
          if (componentInRecipe){
            const storeItem = this.standardNavigation.menu.find((item: ItemObject) => item.id === componentName);
            const display_name_parent = this.translations[`component${componentName}`];
            let parentNode: ItemObject = {
              id: componentName,
              image: [],
              isChecked: false,
              name: display_name_parent ? display_name_parent : componentName,
              active: false,
              visible: true,
              ugc_enable: pdmComponent.hasOwnProperty('ugc'),
              hasPersonalization: this.pdm.components.personalization?.personalization_sibling_component === componentName ?? false
            };

            this.setFeatureAllowedIcons(featureAllowed, parentNode);

            if (storeItem) {
              parentNode.isChecked = storeItem.isChecked;
            }

            const parentNodeStore = cloneDeep(parentNode);
            if (this.activeComponent !== '') this.activeItemId = this.activeComponent;
            parentNodeStore.active = this.activeItemId === componentName ? true : false;

            this.gdm.data.forEach((element: IGraphic) => {
              if(element.component3D === componentName){
                const children: ItemObject[] = [];
                const childrenStore: ItemObject[] = [];
                element.component.map((item:GraphicComponent) => {
                  const replace_name = item.name ? item.name.replace(' ', '_') : '';
                  const isActive = this.standardNavigation.activeSubComponent?
                         this.standardNavigation.activeSubComponent === item.id && this.activeComponent.search(componentName) !== -1
                         : false;
                  const childItem: ItemObject = {
                    id: item.id,
                    image: [],
                    isChecked: false,
                    // Use it when the translation file has everything available
                    // name: this.translations[`Apparel_${replace_name}`]
                    name: item.name ? item.name : '',
                    active: isActive,
                    ugc_enable: item.ugc_enable,
                    visible: true
                  }

                  if (this.enableUGC && item.ugc_enable && ugcAllowed) {
                    childItem.image = [cameraIcon];
                  }

                  const childrenItemsStore: ItemObject = { ...childItem };
                  childrenItemsStore.translation_key = replace_name;

                  if (componentInRecipe.sub_components) {
                    const subComponentName =`${componentName}/${item.id}`;
                    const componentInSelectedSwatches = this.selectedSwatch[subComponentName];
                    childItem.isChecked = componentInSelectedSwatches ? componentInSelectedSwatches.edited : false;
                    childrenItemsStore.isChecked = componentInSelectedSwatches ? componentInSelectedSwatches.edited : false;
                  }

                  children.push(childItem);
                  childrenStore.push(childrenItemsStore);
                });
                parentNode.children = children;
                parentNodeStore.children = childrenStore;
              }
            });
            this.items.push(parentNode);
            tempItems.push(parentNodeStore);
          }
        });

        const previousActiveComponent = this.standardNavigation.activeComponent;
        const previousActiveSubComponent = this.standardNavigation.activeSubComponent;
        this.$store.commit("standardNavigation/SET_STANDARD_NAVIGATION", {
          activeComponent: !!previousActiveComponent ? previousActiveComponent : this.activeItemId,
          activeSubComponent: !!previousActiveSubComponent? previousActiveSubComponent: '',
          menu: tempItems
        });
      }
    },
    updateMainNav(menu: ItemObject[]) {
      this.$nextTick(() => {
        const featureAllowed = this.checkFeatureAllowed();
        let menuItem: ItemObject | undefined = menu?.find(item => item?.id === this.activeComponent);
        let menusubItem: ItemObject | undefined;

        this.items = this.standardNavigation.menu;

        if (this.activeComponent?.search('/') !== -1) {
          const component = this.activeComponent.split('/');
          menuItem = menu?.find(item => item?.id === component[0]);
          if (menuItem?.children) {
            menusubItem = menuItem.children.find(item => item.id === component[1]);
          }
        }

        if (this.isApparel) {
          this.updateMainNavApparel({ menuItem, menusubItem, ...featureAllowed });
        } else {
          if(this.recipe_v2?.components?.[this.activeComponent]?.hasOwnProperty("ugc")) {
            menu?.filter(item => this.recipe_v2?.components?.[item?.id]?.hasOwnProperty("ugc")).forEach(ugcItem => {
              this.updateMainNavFootwear({ menuItem:ugcItem, menusubItem, ...featureAllowed });
            })
          }
          else {
            this.updateMainNavFootwear({ menuItem, menusubItem, ...featureAllowed });
          }
        }
      });
    },
    updateMainNavApparel({ menuItem, menusubItem, ugcAllowed }: any): void {
      this.items.map((item: ItemObject) => {
        const { children, id: itemId } = item;

        if (menuItem && !menusubItem && menuItem?.id === itemId) {
          menuItem.isChecked = !!this.selectedSwatch[this.activeComponent]?.edited;
        }

        if (children) {
          item.children = children?.map((childItem: ItemObject) => {
            const { id: childItemId } = childItem;

            if (this.enableUGC && childItem.ugc_enable) {
              childItem.image = ugcAllowed ? [cameraIcon] : [];
            }

            if (menuItem?.id === itemId && menusubItem?.id === childItemId) {
              childItem.isChecked = !!this.selectedSwatch[this.activeComponent]?.edited;
            }
            // This is to re-check the components with swatches when adding a graphic.
            if (this.selectedSwatch[`${ itemId }/${ childItemId }`]?.edited &&
              !childItem.isChecked) {
              childItem.isChecked = true;
            }

            return { ...childItem };
          });
        }
      });
    },
    updateMainNavFootwear({ menuItem, menusubItem, ...featureAllowed }: any): void {
      this.items.map((item: ItemObject) => {
        const { id: itemId } = item;

        if (menuItem && !menusubItem && menuItem?.id === itemId) {
          if(this.recipe_v2?.components?.[menuItem?.id]?.hasOwnProperty("ugc"))
          {
            menuItem.isChecked = true;
          } else {
          menuItem.isChecked = !this.selectedSwatch[this.activeComponent]?.default;
          }
        }

        this.setFeatureAllowedIcons(featureAllowed, item);
      });
    },
    checkFeatureAllowed(): any {
      const { components } = this.recipe_v2;
      const { swatchesRelation } = this.$store.state.swatches;
      const activeCurrentComponent = this.activeComponent.split('/')[0];
      const componentsWithUGC = this.getComponentsWithUGC();
      let componentsWithUGCExclusive: string[] = [];
      let componentsWithPersonalizationExclusive: string[] = [];
      let subComponentsWithUGCExclusive: string[] = [];
      let relation: SwatchRelation;

      for (const component in components) {
        const componentData: IComponentTemplate | any = components[component];
        const subComponents = componentData.sub_components;
        if(!Object.keys(swatchesRelation).length) {
          this.$store.dispatch("swatches/GET_RELATION_SWATCH_BY_SWATCH", componentData.swatch_id)
          relation = swatchesRelation[componentData.swatch_id];
        } else {
          relation = swatchesRelation[componentData.swatch_id];
        }
        if (relation && !relation.ugc_allowed &&
          (!this.isApparel && componentsWithUGC.includes(component) ||
          !componentsWithUGC.includes(component))) {
          componentsWithUGCExclusive.push(component);
        }
        if (relation && !relation.personalization_allowed) {
          componentsWithPersonalizationExclusive.push(component);
        }

        if (subComponents) {
          for (const subComponent in subComponents) {
            relation = swatchesRelation[subComponents[subComponent].swatch_id];

            if ((!componentsWithUGC.includes(subComponent) ||
              activeCurrentComponent !== component && componentsWithUGC.includes(subComponent)) &&
              relation && !relation.ugc_allowed) {
              subComponentsWithUGCExclusive.push(subComponent);
            }
          }
        }
      }
      return {
        componentsWithUGCExclusive,
        personalizationAllowed: !componentsWithPersonalizationExclusive.length,
        ugcAllowed: !componentsWithUGCExclusive.length && !subComponentsWithUGCExclusive.length,
      };
    },
    getComponentsWithUGC(): string[] {
      const components: string[] = [];

      this.standardNavigation.menu.forEach((menuItem: ItemObject) => {
        const { children } = menuItem;

        if (!this.isApparel && menuItem.ugc_enable) {
          components.push(`${ menuItem.id }`);
        }

        if (children) {
          children.forEach((menuChildItem: ItemObject) => {
            if (menuChildItem.ugc_enable) {
              components.push(`${ menuChildItem.id }`);
            }
          })
        }
      });

      return components;
    },
    getHeightNavigation(): void {
      const apparelNavigationDOM: HTMLElement | null = document.getElementById('standard-navigation');
      if (apparelNavigationDOM){
        // 310px height of header / swatches-view / tabs / arrow navigation / 30px margin (15px top - 15px bottom)
        apparelNavigationDOM.style.maxHeight = `${window.innerHeight - 340}px`;
      }
    },
    hideShowNavigation(): void {
      this.isVisible = !this.isStandardMenuOpen;
      this.$store.commit('standardNavigation/IS_PREVIOUS_MENU_STATE_OPEN', this.isVisible);
      this.$store.commit('standardNavigation/IS_STANDARD_MENU_OPEN', this.isVisible);
    },
    setFeatureAllowedIcons(featureAllowed: any, item: ItemObject): void {
      const menuIcons: string[] = [];
      const { id: itemId } = item;
      const { ugcAllowed } = featureAllowed;

      if (this.noPaletteLockOrUniqueSwatches) {
        if (this.enablePersonalization && item.hasPersonalization &&
          featureAllowed.personalizationAllowed) {
          menuIcons.push(editIcon);
        }

        if (this.enableUGC && item.ugc_enable) {
          const hasUGC = !!featureAllowed.componentsWithUGCExclusive
            .filter((component: string) => component !== itemId).length;

          if (ugcAllowed || !ugcAllowed && !hasUGC) {
            menuIcons.push(cameraIcon);
          }
        }

        item.image = menuIcons;
      }
    },
    onTreeItemActivatedRootHandler(params: TreeNode): void {
      (this as any).onTreeItemActivated(params);
      if (this.updateActiveIdOnActivate) this.activeItemId = params.id;
    },
    onTreeItemReceivedFocus(treeItem: ItemObject): void {
      this.focusedTreeItem = treeItem;
    },
    onKeyDown(event: KeyboardEvent): void {
      switch (event.key) {
        case "Home":
          this.onTreeItemGoToFirst();
          break;
        case "End":
          this.onTreeItemGoToLast();
          break;
      }
    },
    onTreeItemGoToFirst(): void {
      const firstChildItem = (this.$refs[
        `standard-navigation-item-0`
      ] as any)[0];
      firstChildItem.getFocus();
    },
    onTreeItemGoToLast(): void {
      const lastChildItemPos = this.items.length - 1;
      const lastChildItem = (this.$refs[
        `standard-navigation-item-${lastChildItemPos}`
      ] as any)[0];
      lastChildItem.focusLastExpandedDescendantItem();
    },
    onActivateUpdatedFlag(value: boolean = true): void {
      this.updatedFlag = value;
    }
  },
  created() {
    this.updatedFlag = !this.isApparel;
    this.uuid = _uuid;
    _uuid++;
    this.activeItemId = this.initialActiveItemId;
    window.addEventListener('resize', this.getHeightNavigation);
    if (this.$store.state.utils.isDesignTransfering ||
      this.$store.state.utils.isDesignTransferApplied) {
      this.ActiveItemSwatch = true;
    }
  },
  mounted() {
    this.$eventBus.$on('navigationActivateUpdatedFlag', this.onActivateUpdatedFlag);
    this.getHeightNavigation();
  }
});
